import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import FinAccountCardMovementDTO from '../interfaces/fin-account-card-movement-dto';
import FinSupplierAccountDTO from '../interfaces/fin-supplier-account-dto';
import FinSupplierAccountResponse from '../interfaces/fin-supplier-account-response';
import FinSupplierCardDTO from '../interfaces/fin-supplier-card-dto';
import { PageResponse } from '../interfaces/ip-page-response';
import { QueryParametersService } from './ip-query-parameter.service';

@Injectable({
  providedIn: 'root',
})
export class FnAccountFinanceService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) { }

  getAccountInfo(supplierId?: number): Observable<FinSupplierAccountDTO> {
    let url = `${this.api}/invopay`;
    if (supplierId) {
      url += '/finances-business';
    } else {
      url += '/finances-provider';
    }
    url += '/account';
    if (supplierId) {
      url += `/${supplierId}`;
    }
    return this.http.get<FinSupplierAccountDTO>(url);
  }

  getCardInfo(supplierId?: number): Observable<FinSupplierCardDTO> {
    let url = `${this.api}/invopay`;
    if (supplierId) {
      url += '/finances-business';
    } else {
      url += '/finances-provider';
    }
    url += '/card';
    if (supplierId) {
      url += `/${supplierId}`;
    }
    return this.http.get<FinSupplierCardDTO>(url);
  }

  getSupplierAccounts(
    pagination: IPagination,
    userName: string
  ): Observable<PageResponse<FinSupplierAccountResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );
    if (userName && userName.trim() !== '') {
      params = params.set('userName', userName);
    }
    return this.http.get<PageResponse<FinSupplierAccountResponse>>(
      `${this.api}/invopay/finances-business/suppliers`,
      { params }
    );
  }

  getAccountMovements(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    supplierId?: number
  ): Observable<PageResponse<FinAccountCardMovementDTO>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );
    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }

    let url = `${this.api}/invopay`;
    if (supplierId) {
      url += '/finances-business';
    } else {
      url += '/finances-provider';
    }
    url += '/account/movements';
    if (supplierId) {
      url += `/${supplierId}`;
    }

    return this.http.get<PageResponse<FinAccountCardMovementDTO>>(url, {
      params,
    });
  }

  getCardMovements(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    supplierId?: number
  ): Observable<PageResponse<FinAccountCardMovementDTO>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );
    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }

    let url = `${this.api}/invopay`;
    if (supplierId) {
      url += '/finances-business';
    } else {
      url += '/finances-provider';
    }
    url += '/card/movements';
    if (supplierId) {
      url += `/${supplierId}`;
    }

    return this.http.get<PageResponse<FinAccountCardMovementDTO>>(url, {
      params,
    });
  }

  blockCard(blockReason: string): Observable<Boolean> {
    return this.http.post<Boolean>(
      `${this.api}/invopay/finances-provider/card/block`,
      {
        blockReason
      }
    );
  }

  blockCardFromEnterprise(blockReason: string, supplierId: number): Observable<Boolean> {
    return this.http.post<Boolean>(
      `${this.api}/invopay/finances-business/card/block/${supplierId}`,
      {
        blockReason
      }
    );
  }
}
